import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "../Button";
import { Flex } from "../Flex";
export default function DialogFooterSection({ title, primaryButton, secondaryButton, tertiaryButton, onClose, }) {
    const [loadingPrimary, setLoadingPrimary] = useState(false);
    const [loadingSecondary, setLoadingSecondary] = useState(false);
    const [loadingTertiary, setLoadingTertiary] = useState(false);
    const shouldShowButton = (button) => {
        return button?.label && !button.hide;
    };
    return (_jsxs(Flex, { direction: { small: "column", medium: "row" }, justifyContent: { small: "center", medium: "flex-end" }, gap: "16px", padding: "16px", margin: "auto 0 0 0", children: [shouldShowButton(tertiaryButton) && (_jsx(Button, { onClick: async () => {
                    setLoadingTertiary(true);
                    await tertiaryButton?.onClick?.();
                    setLoadingTertiary(false);
                }, "data-testid": `dialog-${title?.slugify()}-tertiary-button`, variant: "text", href: tertiaryButton?.href, width: "auto", minWidth: tertiaryButton?.minWidth || "120px", loading: loadingTertiary, children: tertiaryButton?.label })), shouldShowButton(secondaryButton) && (_jsx(Button, { onClick: async () => {
                    setLoadingSecondary(true);
                    await secondaryButton?.onClick?.();
                    setLoadingSecondary(false);
                    onClose?.();
                }, "data-testid": `dialog-${title?.slugify()}-secondary-button`, variant: "secondary", href: secondaryButton?.href, width: "auto", minWidth: secondaryButton?.minWidth || "120px", loading: loadingSecondary, children: secondaryButton?.label })), shouldShowButton(primaryButton) && (_jsx(Button, { onClick: async () => {
                    setLoadingPrimary(true);
                    await primaryButton?.onClick?.();
                    setLoadingPrimary(false);
                    onClose?.();
                }, "data-testid": `dialog-${title?.slugify()}-primary-button`, variant: "primary", href: primaryButton?.href, width: "auto", minWidth: primaryButton?.minWidth || "120px", loading: loadingPrimary, children: primaryButton?.label }))] }));
}
//# sourceMappingURL=FooterSection.js.map